function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { BidirectionalMap } from '../BidirectionalMap';
export class NormalizedManager {
    mapForLink(link) {
        return link.link_type === 'Asset' ? this.assets : this.entries;
    }
    getOrAdd(link, factory) {
        let normalized = this.get(link);
        if (!normalized) {
            const map = this.mapForLink(link);
            // This is required in order to handle
            // ciricular resolutions. Because this method
            // may be called recursively from `factory()`
            // we need to make sure that the normalized object
            // already "exists" even if we haven't finished the
            // resolution of the tree. By defining the object
            // and then "exanding" the factory result into it
            // we make sure that calls to both `getOrAdd()` and
            // `get()` from inside `factory()` will resolve to the
            // same reference returned from the call, therefore allowing
            // circular building.
            const consistentReferenceObject = {};
            map.set(link.primary_key, consistentReferenceObject);
            try {
                normalized = factory();
            } catch (err) {
                // If the factory errored we need to
                // clear this temp value out, as we didn't
                // actually factory it and we don't want any downstream
                // parsing to actually get this value.
                map.deleteA(link.primary_key);
                throw err;
            }
            for (const [k, v] of Object.entries(normalized)){
                consistentReferenceObject[k] = v;
            }
            normalized = consistentReferenceObject;
        }
        return normalized;
    }
    get(link) {
        return this.mapForLink(link).getByA(link.primary_key);
    }
    getLink(normalized) {
        const entryId = this.entries.getByB(normalized);
        if (entryId) {
            return {
                primary_key: entryId,
                link_type: 'Entry'
            };
        }
        const assetId = this.assets.getByB(normalized);
        if (assetId) {
            return {
                primary_key: assetId,
                link_type: 'Asset'
            };
        }
    }
    has(normalized) {
        return this.entries.hasB(normalized) || this.assets.hasB(normalized);
    }
    visitNormalizedReferencesInternal(normalized, visitor, skipInitial = false) {
        if (Array.isArray(normalized)) {
            return normalized.map((v)=>this.visitNormalizedReferencesInternal(v, visitor));
        } else if (!!normalized && typeof normalized === 'object') {
            if (this.has(normalized) && !skipInitial) {
                return visitor(normalized);
            } else {
                return Object.entries(normalized).reduce((p, [k, v])=>_object_spread_props(_object_spread({}, p), {
                        [k]: this.visitNormalizedReferencesInternal(v, visitor)
                    }), {});
            }
        } else {
            return normalized;
        }
    }
    visitNormalizedReferences(normalized, visitor) {
        return this.visitNormalizedReferencesInternal(normalized, visitor, true);
    }
    constructor(){
        _define_property(this, "entries", new BidirectionalMap());
        _define_property(this, "assets", new BidirectionalMap());
    }
}

//# sourceMappingURL=NormalizedManager.js.map